import { Link } from "react-router-dom";
import logoLanding from "@/assets/logo-dark.svg";

export const LandingFooter = () => {
  return (
    <footer className="relative w-full py-12 px-6 md:px-12 overflow-hidden bg-[#272D37]">
      {/* Subtle Aqueous Background */}
      <div
        className="absolute top-0 left-0 w-[500px] h-[500px] rounded-full opacity-5 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(255, 209, 102, 0.6) 0%, rgba(255, 209, 102, 0) 70%)",
          animation: "float 30s ease-in-out infinite",
        }}
      ></div>
      <div
        className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full opacity-5 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(216, 222, 233, 0.5) 0%, rgba(216, 222, 233, 0) 70%)",
          animation: "float 35s ease-in-out infinite reverse",
        }}
      ></div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo and Description */}
          <div
            className="md:col-span-2"
            style={{
              animation: "fadeInUp 0.8s ease-out",
            }}
          >
            <img src={logoLanding} alt="KopfAI" width="198" height="40" className="w-auto h-10 mb-4" />
            <p className="text-sm text-white/80 max-w-sm leading-relaxed">
              Sua IA pessoal para bem-estar mental, baseada em Terapia Cognitivo-Comportamental.
            </p>
          </div>

          {/* Product Links */}
          <div
            style={{
              animation: "fadeInUp 0.8s ease-out 0.2s backwards",
            }}
          >
            <h3 className="text-sm font-bold mb-4 text-white flex items-center gap-2">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#FFD166]"></span>
              Produto
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/auth"
                  className="text-sm text-white/70 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block group"
                >
                  <span className="relative">
                    Login
                    <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-[#FFD166] group-hover:w-full transition-all duration-300"></span>
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-sm text-white/70 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block group"
                >
                  <span className="relative">
                    Perguntas frequentes
                    <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-[#FFD166] group-hover:w-full transition-all duration-300"></span>
                  </span>
                </Link>
              </li>
              <li>
                <a
                  href="https://blog.kopfai.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/70 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block group"
                >
                  <span className="relative">
                    Blog
                    <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-[#FFD166] group-hover:w-full transition-all duration-300"></span>
                  </span>
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div
            style={{
              animation: "fadeInUp 0.8s ease-out 0.4s backwards",
            }}
          >
            <h3 className="text-sm font-bold mb-4 text-white flex items-center gap-2">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#FFD166]"></span>
              Legal
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/termos?tab=privacy"
                  className="text-sm text-white/70 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block group"
                >
                  <span className="relative">
                    Privacidade
                    <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-[#FFD166] group-hover:w-full transition-all duration-300"></span>
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/termos?tab=terms"
                  className="text-sm text-white/70 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block group"
                >
                  <span className="relative">
                    Termos de Uso
                    <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-[#FFD166] group-hover:w-full transition-all duration-300"></span>
                  </span>
                </Link>
              </li>
              <li>
                <a
                  href="mailto:contato@kopfai.com"
                  className="text-sm text-white/70 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block group"
                >
                  <span className="relative">
                    Contato
                    <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-[#FFD166] group-hover:w-full transition-all duration-300"></span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div
          className="border-t border-white/10 pt-8"
          style={{
            animation: "fadeInUp 0.8s ease-out 0.6s backwards",
          }}
        >
          <div className="flex flex-col md:flex-row items-center justify-center gap-2">
            <p className="text-sm text-white/60 text-center">
              © {new Date().getFullYear()} KopfAI. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { 
            transform: translate(0, 0) scale(1); 
          }
          50% { 
            transform: translate(30px, 30px) scale(1.1); 
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </footer>
  );
};
